// Débitos avulsos da ficha em aberto (contratos com saldo): o que está num acordo ativo se baixa pelas parcelas dele
import React from "react";
import { Checkbox, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { toCurrency } from "utils/NumberUtils";
import { useMaterialUIController } from "context";
import { coresDoTema, FONTE } from "assets/coresTema";
import { dataBR, corDaSituacao } from "./baixaUtils";

const COLUNAS = ["", "Débito", "Vencimento", "Valor original", "Saldo", "Situação"];

export default function TabelaDebitos({ debitos, selecionados, onAlternar }) {
    const [controller] = useMaterialUIController();
    const cores = coresDoTema(controller.darkMode);

    if (!debitos || debitos.length === 0) {
        return (
            <MDBox py={4} textAlign="center">
                <MDTypography variant="button" color="text">Nenhum débito avulso em aberto nesta ficha.</MDTypography>
            </MDBox>
        );
    }

    return (
        <TableContainer sx={{ border: `1px solid ${cores.borda}`, borderRadius: 2 }}>
            <Table size="small" sx={{ minWidth: 560 }}>
                <TableHead sx={{ display: "table-header-group" }}>
                    <TableRow>
                        {COLUNAS.map((c, i) => (
                            <TableCell key={i} align={i === 3 || i === 4 ? "right" : "left"}
                                sx={{ py: 0.75, px: 1, width: i === 0 ? 40 : undefined, backgroundColor: cores.painelEscuro }}>
                                <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ fontSize: FONTE.cabecalho }}>{c}</MDTypography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {debitos.map(d => {
                        const livre = !d.acordoAtivo;
                        const marcado = Boolean(selecionados[d.id]);
                        return (
                            <TableRow key={d.id} hover={livre} onClick={() => livre && onAlternar(d)}
                                sx={{ cursor: livre ? "pointer" : "default", backgroundColor: marcado ? cores.hover : undefined }}>
                                <TableCell sx={{ py: 0.25, px: 1 }}>
                                    {livre && (
                                        <Checkbox size="small" checked={marcado} onClick={(e) => e.stopPropagation()} onChange={() => onAlternar(d)}
                                            inputProps={{ "aria-label": d.titulo || "Débito" }} />
                                    )}
                                </TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}>
                                    <MDTypography variant="button" fontWeight="medium" display="block">
                                        {d.titulo || "-"}{d.parcela ? ` · parcela ${d.parcela}` : ""}
                                    </MDTypography>
                                    {!livre && (
                                        <MDTypography variant="caption" color="text" display="block">
                                            No acordo #{d.acordoAtivo}: baixe pelas parcelas do acordo
                                        </MDTypography>
                                    )}
                                </TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="button">{dataBR(d.vencimento)}</MDTypography></TableCell>
                                <TableCell align="right" sx={{ py: 0.75, px: 1 }}><MDTypography variant="button">{toCurrency(d.valorOriginal)}</MDTypography></TableCell>
                                <TableCell align="right" sx={{ py: 0.75, px: 1 }}><MDTypography variant="button" fontWeight="bold">{toCurrency(d.saldo)}</MDTypography></TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}>
                                    <Chip size="small" variant="outlined" color={corDaSituacao(d.situacao)} label={d.situacao} />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
